import styled from 'styled-components';

export const Page = styled.div`
  padding-bottom: 40px;
`;

export const Header = styled.section`
  max-width: ${({ theme }) => theme.container};
  margin: 24px auto 0; padding: 0 16px;
  display: grid; grid-template-columns: 1fr 1fr; gap: 16px;
  @media (max-width: 900px){ grid-template-columns: 1fr; }
`;

export const HeaderCard = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  border-radius: 12px; padding: 24px;
  h1{ margin:0 0 12px; color: ${({ theme }) => theme.colors.green[700]}; font-size: 32px;}
  p{ margin: 0; color: ${({ theme }) => theme.colors.text}; line-height: 1.6; }
`;

export const HeaderImage = styled.div`
  border-radius: 12px; overflow: hidden; background: ${({ theme }) => theme.colors.gray[100]}; min-height: 220px;
  img{ width:100%; height:100%; object-fit: cover; }
`;

export const Section = styled.section`
  max-width: ${({ theme }) => theme.container};
  margin: 32px auto 0; padding: 0 16px;
`;

export const SectionTitle = styled.h2`
  font-size: 24px; color: ${({ theme }) => theme.colors.green[800]};
  margin-bottom: 16px; border-bottom: 2px solid ${({ theme }) => theme.colors.green[100]}; padding-bottom: 8px;
`;

export const Accordion = styled.div`
  display: flex; flex-direction: column; gap: 12px;
`;

export const AccordionItem = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  border-radius: 8px; background: #fff; overflow: hidden;
`;

export const AccordionHeader = styled.div`
  padding: 16px; cursor: pointer;
  display: flex; justify-content: space-between; align-items: center;
  background: ${({ $expanded, theme }) => $expanded ? theme.colors.green[50] : '#fff'};
  font-weight: 600; color: ${({ theme }) => theme.colors.green[800]};
  transition: background 0.2s;
  &:hover { background: ${({ theme }) => theme.colors.green[50]}; }
`;

export const AccordionContent = styled.div`
  padding: 16px; border-top: 1px solid ${({ theme }) => theme.colors.gray[200]};
  line-height: 1.6;
  p { margin-bottom: 12px; }
  a { color: ${({ theme }) => theme.colors.green[600]}; font-weight: 600; text-decoration: underline; }
`;

export const FormCard = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  border-radius: 12px; padding: 24px; box-shadow: ${({ theme }) => theme.shadows.sm};
  margin-top: 16px;
`;

export const Field = styled.div`
  margin-bottom: 16px;
  label { display:block; margin-bottom: 6px; color: ${({ theme }) => theme.colors.text}; font-weight: 500; }
  input, textarea, select {
    width: 100%; padding: 12px; border: 1px solid ${({ theme }) => theme.colors.gray[300]}; border-radius: 10px; background: #fff;
    font-size: 14px;
    &:focus { outline: 2px solid ${({ theme }) => theme.colors.green[200]}; border-color: ${({ theme }) => theme.colors.green[500]}; }
  }
  textarea { min-height: 100px; resize: vertical; }
  
  .checkbox-group {
    display: flex; flex-wrap: wrap; gap: 12px;
    label { font-weight: normal; display: flex; align-items: center; gap: 6px; margin: 0; cursor: pointer; }
    input[type="checkbox"] { width: auto; margin: 0; }
  }
`;

export const Button = styled.button`
  padding: 14px 24px; border:none; border-radius: 10px; 
  background: ${({ theme }) => theme.colors.green[600]}; 
  color:#fff; font-weight:600; font-size: 16px; cursor:pointer;
  transition: background 0.2s;
  &:hover { background: ${({ theme }) => theme.colors.green[700]}; }
  &:disabled { background: ${({ theme }) => theme.colors.gray[400]}; cursor: not-allowed; }
`;

export const Grid2 = styled.div`
  display: grid; grid-template-columns: 1fr 1fr; gap: 16px;
  @media (max-width: 600px) { grid-template-columns: 1fr; }
`;

export const TabNav = styled.div`
  display: flex; gap: 16px; margin-bottom: 24px; border-bottom: 1px solid ${({ theme }) => theme.colors.gray[200]};
  margin-top: 24px;
`;

export const Tab = styled.button`
  padding: 12px 24px; background: none; border: none; border-bottom: 3px solid transparent;
  font-weight: 600; color: ${({ theme }) => theme.colors.text}; cursor: pointer; font-size: 16px;
  ${({ $active, theme }) => $active && `
    border-bottom-color: ${theme.colors.green[600]}; color: ${theme.colors.green[700]};
  `}
`;
